class WishlistManager {
  constructor() {
    this.storageKey = "shopify_wishlist";
  }
  getWishlist() {
    try {
      const wishlist = localStorage.getItem(this.storageKey);
      return wishlist ? JSON.parse(wishlist) : [];
    } catch (error) {
      console.error("Error reading wishlist:", error);
      return [];
    }
  }
  addToWishlist(productId) {
    const wishlist = this.getWishlist();
    if (!wishlist.includes(productId)) {
      wishlist.push(productId);
      this.saveWishlist(wishlist);
      this.dispatchWishlistUpdate();
      return true;
    }
    return false;
  }
  removeFromWishlist(productId) {
    let wishlist = this.getWishlist();
    const index = wishlist.indexOf(productId);
    if (index > -1) {
      wishlist.splice(index, 1);
      this.saveWishlist(wishlist);
      this.dispatchWishlistUpdate();
      return true;
    }
    return false;
  }
  isInWishlist(productId) {
    return this.getWishlist().includes(productId);
  }
  saveWishlist(wishlist) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));
    } catch (error) {
      console.error("Error saving wishlist:", error);
    }
  }
  dispatchWishlistUpdate() {
    window.dispatchEvent(
      new CustomEvent("wishlist:updated", {
        detail: { wishlist: this.getWishlist() }
      })
    );
  }
}
const wishlistManager = new WishlistManager();
class AddToWishlist extends window.HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute("product-id");
    this.textElement = null;
  }
  connectedCallback() {
    if (!this.productId) {
      console.error("product-id attribute is required");
      return;
    }
    this.textElement = this.querySelector("[data-wishlist-text]");
    this.updateActiveState();
    this.addEventListener("click", this.handleClick.bind(this));
    window.addEventListener(
      "wishlist:updated",
      this.updateActiveState.bind(this)
    );
  }
  disconnectedCallback() {
    window.removeEventListener(
      "wishlist:updated",
      this.updateActiveState.bind(this)
    );
  }
  handleClick(e) {
    e.preventDefault();
    const isInWishlist = wishlistManager.isInWishlist(this.productId);
    if (isInWishlist) {
      wishlistManager.removeFromWishlist(this.productId);
    } else {
      wishlistManager.addToWishlist(this.productId);
    }
    this.updateActiveState();
  }
  updateActiveState() {
    const isInWishlist = wishlistManager.isInWishlist(this.productId);
    if (isInWishlist) {
      this.classList.add("active");
      this.setAttribute("aria-pressed", "true");
      if (this.textElement) {
        this.textElement.textContent = "Remove from Wishlist";
      }
    } else {
      this.classList.remove("active");
      this.setAttribute("aria-pressed", "false");
      if (this.textElement) {
        this.textElement.textContent = "Add to Wishlist";
      }
    }
  }
}
window.customElements.define("add-to-wishlist", AddToWishlist);
